import { Component, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { ManagePermissionsComponent } from './manage-permissions/manage-permissions.component';
import { SettingsComponent } from '../../settings/settings.component';
import { AuthenticationService } from '../../../services/authentication.service';
import { PERMISSIONS } from '../../../models/constants';

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [NgIf, ManagePermissionsComponent, SettingsComponent],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.css'
})
export class AdminComponent implements OnInit {
  constructor(private authenticationService: AuthenticationService) {}

  isAdmin = false;
  activeTab: 'permissions' | 'cameras' = 'cameras';

  async ngOnInit() {
    this.isAdmin = await this.authenticationService.userHasPermission(PERMISSIONS.ADMIN);
    this.activeTab = this.isAdmin ? 'permissions' : 'cameras';
  }

  setTab(tab: 'permissions' | 'cameras') {
    if (tab === 'permissions' && !this.isAdmin) {
      return;
    }
    this.activeTab = tab;
  }
}
